module.exports = __webpack_public_path__ + "static/img/88029B_1_V_20220606_LC.923e1ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/88029B_1_V_20220606_LC.png
// module id = Y1i4
// module chunks = 0